<template>
  <div
    v-if="slide.name"
    ref="canvas-preview"
    class="canvas-preview__content"
  >
    <div
      v-if="slide.error"
      class="vertical layout center center-justified content__text"
    >
      <div class="content__text-icon" :class="{'has-icon-inside': slide.type === 'question'}">
        <aha-icon
          v-if="slide.ahaIcon && textColour === '#313131'"
          :name="slide.ahaIcon"
          :maintainColor="true"
          width="120"
          height="120"
          viewBox="0 0 30 30"
        />
        <aha-icon
          v-if="slide.ahaIconWhite && textColour === '#ffffff'"
          :name="slide.ahaIconWhite"
          :maintainColor="true"
          width="120"
          height="120"
          viewBox="0 0 30 30"
        />
      </div>

      <h2 class="heading-md-title content__text-heading">
        {{ slide.name }}
      </h2>
      <p class="text-center subheading-sm-title content__text-description">
        {{ slide.desc }}
      </p>
    </div>
    <div
      v-else
    >
      <div
        v-if="isVisualTypeVideo(slide.visualType)"
        class="content__bg rounded-md"
      >
        <video
          autoplay
          loop
          preload="auto"
        >
          <source :src="slide.previewUrlVisual" type="video/webm">
          {{ $t('Your browser does not support the video tag.') }}
        </video>
      </div>
      <div
        v-else-if="!isVisualTypeVideo(slide.visualType)"
        class="content__bg"
        :style="{ 'background-image':
          'url(' + slide.previewUrlVisual + ')'
        }"
      ></div>
      <div
        v-else-if="getPresenterLocale === 'fr'"
        class="content__bg bg-base-0"
        :style="{ 'background-image':
          'url(' + slide.previewUrlFr + ')'
        }"
      >
      </div>
      <div
        v-else
        class="content__bg bg-base-0"
        :style="{ 'background-image':
          'url(' + slide.previewUrl + ')'
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import EventBus from '@/eventBus'
import { VISUAL_TYPE } from '@/constant/slideTypes'
import SLIDE_ACTIVE_TABS from '@/constant/slideActiveTabs'

export default {
  props: {
    wrapperId: {
      type: String,
      required: false,
      default: '',
    },
    defaultSlide: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      slide: this.defaultSlide,
    }
  },
  computed: {
    ...mapGetters(['getPresenterLocale']),
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    textColour() {
      return this.slideActive && this.slideActive.textColour
    },
    activeTab() {
      return this.slideActive && this.slideActive.activeTab
    },
  },
  watch: {
    'slideActive.id': {
      handler() {
        this.slide = {}
      },
      immediate: true,
    },
  },
  mounted() {
    EventBus.$on('handleHoverOnSlideType', this.handleHoverOnSlideType)
  },
  destroyed() {
    EventBus.$off('handleHoverOnSlideType', this.handleHoverOnSlideType)
  },
  methods: {
    handleHoverOnSlideType(slide, mode, wrapperId) {
      if (this.wrapperId !== wrapperId) return

      if (
        wrapperId === 'right-side'
        && mode === 'over'
        && this.activeTab !== SLIDE_ACTIVE_TABS.SLIDE_TYPES
      ) return

      if (mode === 'out') {
        this.slide = {}

        return
      }

      if (this.$store.state.slideTypePreview[slide.preview]) {
        slide.error = this.$store.state.slideTypePreview[slide.preview].error
      }

      this.slide = slide
    },

    isVisualTypeVideo(type) {
      return type === VISUAL_TYPE.VIDEO
    },
  },
}
</script>

<style lang="scss" scoped>
.canvas-preview__content {
  height: 110%;
  .content__text {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1000; // To overlay QnA session w z-index: 999
    .content__text-heading {
      font-weight: bold;
      padding-bottom: 15px; // Padding of textSlide's heading
    }
    .content__text-description {
      width: 80%; // CSS of textSlides' subheading
      opacity: 0.85;
    }
    .content__text-icon {
      .content__text-icon-bullet {
        font-size: 3rem;
      }
    }
  }

  .content__bg  {
    @apply w-full h-full absolute top-0 left-0 z-30 rounded-md;
    @apply bg-cover bg-no-repeat bg-center;

    video {
      @apply rounded-md;
      height: 100%;
      max-width: none;
    }
  }
}
.has-icon-inside {
  .fa-comment {
    position: relative;

    &:after {
      content: "\F128";
      position: absolute;
      color: #fff;
      left: 31%;
      z-index: 1;
      font-size: 0.5em;
      top: 22%;
    }
  }
}
</style>
